// @flow

import Vue from 'vue';
import Vuex from 'vuex';
import Game from '@/lib/game';
import Timer from '@/lib/timer';

Vue.use(Vuex);

const permittedUserActions = ['seed', 'cut'];
const permittedSpeedPercentages = [25, 50, 100, 200, 400, 800]; // 単位: ％

export default new Vuex.Store({
  state: {
    game: null,
    userActionMode: null,
    selectedSeed: null,
    selectedSeedsCount: 0,
    seedsCount: {},
    // TODO: 以下は lib/game/game.js と重複管理されているのでうまく統合したい
    speedPercentageId: 2, // = 100%
    readIntro4: false, // Aランクを目指しましょうのメッセージ
  },
  getters: {
    speedPercentage(state) {
      return permittedSpeedPercentages[state.speedPercentageId];
    },
    isMinSpeed(state) {
      return state.speedPercentageId === 0;
    },
    isMaxSpeed(state) {
      return state.speedPercentageId === permittedSpeedPercentages.length - 1;
    },
  },
  actions: {
    mainLoop() {
      const game = new Game();
      game.main();
      this.commit('startGame', game);
    },
    async readNotification(context, id) {
      await Timer.sleep(2000);
      this.commit('readNotification', id);
    },
    readTutorial(context, uid) {
      this.commit('readTutorial', uid);
    },
    userActionCell(context, conditions) {
      const { userActionMode } = this.state;

      if (userActionMode === 'seed') {
        if (context.state.selectedSeed === null) {
          alert('種を選択してください');
          return;
        }

        conditions.seed = context.state.selectedSeed;
      }

      if (permittedUserActions.includes(userActionMode)) {
        this.state.game.doUserAction(userActionMode, conditions);
        this.dispatch('updateSeedsCount');
      }

      return userActionMode;
    },
    setUserActionMode(context, conditions) {
      const { mode, toggle } = conditions;

      if (this.state.userActionMode === mode && toggle) {
        this.commit('setUserActionMode', null);
      } else {
        this.commit('setUserActionMode', mode);
      }

      this.dispatch('updateSeedsCount');
    },
    setObservers(context, { actions }) {
      this.state.game.addObserverActions(actions);
    },
    selectSeed(context, unitTemplate) {
      this.commit('selectSeed', unitTemplate);
    },
    buyItem(context, unitTemplate) {
      const result = this.state.game.shop.buy(unitTemplate);

      if (typeof result === 'object' && result === false && result.message) {
        alert(result.message);
      }

      this.dispatch('updateSeedsCount');
    },
    updateSeedsCount(context) {
      const seedsCount = this.state.game.shop.itemList().reduce((acc, item) => {
        acc[item.type] = this.state.game.assetManager.findUnitAmount(item);
        return acc;
      }, {});

      this.commit('setSeedsCount', seedsCount);
    },
    speedUp() {
      if (this.state.speedPercentageId < permittedSpeedPercentages.length - 1) {
        this.state.speedPercentageId++;
        this.state.game.speedRate =
          permittedSpeedPercentages[this.state.speedPercentageId] / 100;
      }
    },
    speedDown() {
      if (0 < this.state.speedPercentageId) {
        this.state.speedPercentageId--;
        this.state.game.speedRate =
          permittedSpeedPercentages[this.state.speedPercentageId] / 100;
      }
    },
    stopGame() {
      this.commit('stopGame');
    },
    restartGame() {
      this.commit('restartGame');
    },
    showIntro(_, { introjs, selector, message }) {
      this.commit('setUserActionMode', null);
      this.commit('stopGame');

      introjs()
        .addStep({
          element: document.querySelector(selector),
          intro: message,
        })
        .setOptions({
          showStepNumbers: false,
          nextLabel: '>',
          prevLabel: '<',
          skipLabel: 'スキップ',
          doneLabel: '閉じる',
          disableInteraction: true,
          exitOnOverlayClick: false,
          showBullets: false,
          overlayOpacity: 0,
        })
        .start();
      this.commit('restartGame');
    },
    readIntro4() {
      this.commit('readIntro4');
    },
  },
  mutations: {
    startGame(state, game) {
      state.game = game;
    },
    readNotification(state, id) {
      state.game.readNotification(id);
    },
    readTutorial(state, uid) {
      state.game.readTutorial(uid);
    },
    selectSeed(state, unitTemplate) {
      state.selectedSeed = unitTemplate;
      this.commit('refreshSelectedSeed');
    },
    refreshSelectedSeed(state) {
      if (
        !state.selectedSeed ||
        typeof state.seedsCount[state.selectedSeed.type] === 'undefined'
      ) {
        state.selectedSeedsCount = 0;
      } else {
        state.selectedSeedsCount = state.seedsCount[state.selectedSeed.type];
      }

      if (state.selectedSeedsCount === 0) {
        state.selectedSeed = null;
      }
    },
    setUserActionMode(state, userAction) {
      state.userActionMode = userAction;
    },
    setSeedsCount(state, seedsCount) {
      state.seedsCount = seedsCount;
      this.commit('refreshSelectedSeed');
    },
    stopGame(state) {
      state.game.stop = true;
    },
    restartGame(state) {
      state.game.stop = false;
    },
    readIntro4(state) {
      state.readIntro4 = true;
    },
  },
});



// WEBPACK FOOTER //
// ./src/stores/game.js